module.exports = __webpack_public_path__ + "h5/img/noData.34e4882d.png";